<template>
  <div class="v-stats">
    <img alt="OSRS logo" src="../assets/rslogo3.png">
    <Hiscores player="killklojo"></Hiscores>
  </div>
</template>
<script>
  import Hiscores from '@/components/Hiscores.vue';

  export default {
    name: 'stats',
    components: {
      Hiscores,
    },
  };
</script>

<style lang="scss">
  .v-stats {
    margin-top: 1rem;
  }
</style>
